// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// Import everything from booking
import './booking/daterangepicker.js';
import './booking/settings.js';
import './booking/helpers/tools.js';
import './booking/main.js';
import './booking/helpers/google.js'; import './booking/helpers/googleMapStyle.js';
import './booking/api/ajax.js'; import './booking/api/bankid.js'; import './booking/api/claims.js'; import './booking/api/configuration.js'; import './booking/api/models.js'; import './booking/api/opus.js'; import './booking/api/price.js'; import './booking/api/verification.js';
import './booking/views/booking.js'; import './booking/views/clinic.js'; import './booking/views/geo.js'; import './booking/views/health.js'; import './booking/views/homepage.js'; import './booking/views/lastminute.js'; import './booking/views/mypages.js'; import './booking/views/pricelist.js';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js